import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { ControlContext } from "../contexts/ControlContext";

const Banner = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 300;
  background: ${({ theme }) => theme.colors.danger};
  color: #fff;
  text-align: center;
  font-weight: 600;
  font-size: 0.95em;
  line-height: 1.35;
  /* Clear the notch so the message isn't hidden behind the camera. */
  padding: calc(env(safe-area-inset-top, 0px) + 0.7em) 1em 0.7em;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
`;

// Wait a moment before alarming the counter: the socket normally connects in
// well under a second, and a brief drop reconnects on its own within ~1s.
const GRACE_MS = 2500;

// Shows a prominent banner when the count app has lost its connection to the
// server, so counters know their taps may not be saving (the websocket keeps
// retrying in the background; the banner clears itself once it reconnects).
export default function ConnectionBanner() {
  const { connected } = useContext(ControlContext);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (connected) {
      setShow(false);
      return;
    }
    const timer = setTimeout(() => setShow(true), GRACE_MS);
    return () => clearTimeout(timer);
  }, [connected]);

  if (!show) return null;

  return (
    <Banner>
      Can’t reach the server — your counts may not be saved. Trying to
      reconnect…
    </Banner>
  );
}
